// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-update-form-adress {
  width: 564px !important;
  height: 564px !important;
  z-index: 1000;
}
.modal-update-form-adress .ant-modal-content {
  min-height: 540px !important;
  background-size: cover;
  padding: 0;
  height: 100%;
}
.modal-update-form-adress .ant-modal-body {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  min-height: 540px !important;
  overflow-y: auto;
}
.modal-update-form-adress .ant-modal-mask {
  width: 100vw;
  height: 100vh;
  background-color: #000 no-repeat padding-box !important;
  opacity: 0.98px;
  backdrop-filter: blur(40px);
}
.modal-update-form-adress .ant-modal-footer {
  position: absolute;
}
.modal-update-form-adress .container-spa {
  text-align: center;
  align-items: center;
  justify-content: center;
  font: normal normal 200 10px Poppins;
  color: #FFFFFF;
  margin-top: 1%;
}
`, "",{"version":3,"sources":["webpack://./src/components/PopBallon/CustomExtract/ModalCompleteRedemption.less"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,wBAAA;EACA,aAAA;AACJ;AAJA;EAQQ,4BAAA;EACA,sBAAA;EACA,UAAA;EACA,YAAA;AADR;AAVA;EAeQ,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;EACA,4BAAA;EACA,gBAAA;AAFR;AAlBA;EAwBQ,YAAA;EACA,aAAA;EACA,uDAAA;EACA,eAAA;EACA,2BAAA;AAHR;AAzBA;EAgCQ,kBAAA;AAJR;AA5BA;EAoCQ,kBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oCAAA;EACA,cAAA;EACA,cAAA;AALR","sourcesContent":[".modal-update-form-adress {\n    width: 564px !important;\n    height: 564px !important;\n    z-index: 1000;\n\n    .ant-modal-content {\n        padding: 0;\n        height: 100%;\n        min-height: 540px !important;\n        background-size: cover;\n        padding: 0;\n        height: 100%;\n    }\n\n    .ant-modal-body {\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        height: 100%;\n        min-height: 540px !important;\n        overflow-y: auto;\n    }\n\n    .ant-modal-mask {\n        width: 100vw;\n        height: 100vh;\n        background-color: #000 no-repeat padding-box !important;\n        opacity: 0.98px;\n        backdrop-filter: blur(40px);\n    }\n\n    .ant-modal-footer {\n        position: absolute;\n    }\n\n    .container-spa {\n        text-align: center;\n        align-items: center;\n        justify-content: center;\n        font: normal normal 200 10px Poppins;\n        color: #FFFFFF;\n        margin-top: 1%;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
